import { type PageGroup } from '@editor2/types/pageGroup';
import { pick } from './pick';

export const pageGroupToPageGroupProperties = (pageGroup: PageGroup) => {
	const properties = pick(pageGroup, ['family_id', 'name', 'description']);

	return properties;
};
